// import React, { useEffect, useState } from "react";
// import { Tooltip } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { Link, useNavigate } from "react-router-dom";
// import PaginationComponent from "../../../Components/PaginationComponent";
// import toast from 'react-hot-toast';
// import incomeService from "../../../Services/incomeService";
// import medicineService from "../../../Services/medicineService";

// const MedicineStock = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [patients, setPatients] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const getStock = async () => {
//       try {
//         setLoading(true);
//         const response = await medicineService.fetchAll();
//         console.log(response);
//         setPatients(response.medicines);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error('Error fetching Patients');
//       }
//     };
//     getStock();
//   }, []);

//   useEffect(() => {
//     const filteredResult = patients?.filter(
//       (item) =>
//         item?.medicine_name?.toLowerCase().includes(searchData.toLowerCase())
//     ) || [];
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, patients]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const formatDate = (dateString) => {
//     if (!dateString) return ''; // Handle null or undefined
//     const options = { year: 'numeric', month: 'short', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString('en-US', options);
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <div className="flex flex-col">
//           <h1 className="ml-[3%] text-[24px] text-gray-700 font-[700]">Medicines Stock</h1>
//           <h1 className="ml-[3%] text-[9px] bg-[#F07F1B] py-[3px] text-center rounded-full w-24 text-white font-bold">{filteredData?.length || 0} records found</h1>
//         </div>
        
//         <div className="flex mt-8 flex-row-reverse justify-between px-[3%]">
//           <Link to='purchasemedicine'>
//             <button className="bg-white text-[#F07F1B] font-semibold border hover:bg-[#F07F1B] hover:text-white px-8 py-2 rounded-full duration-300">
//               + Medicine 
//             </button>
//           </Link>

//           {/* <Link to='recordpurchases'>
//             <button className="bg-white-50 border-2 h-[2rem] px-4 rounded-md text-black font-[600] text-[14px]">
//               Record Purchases 
//             </button>
//           </Link> */}
//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 rounded-md border-gray-800 bg-white focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-700 ml-2" />
//           </div>
//         </div>

//         <div className="mx-[3%] rounded-lg">
//           <table className="w-[100%] overflow-hidden rounded-lg">
//             <thead className="bg-gray-700">
//               <tr className="text-white text-[12px] capitalize leading-normal">
//               <th className="py-4 w-[15%] text-left pl-4">ID</th>
//                 <th className="py-4 w-[20%] text-left">Name</th>
                
//                 <th className="py-4 w-[20%]">Qty</th>
//                 <th className="py-4 w-[20%]">Price</th>
//                 <th className="py-4 w-[20%]">Supplier Name</th>
//                 <th className="py-4 w-[20%]">Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData?.map((patient) => (
//                 <tr key={patient?.patient_id} className="bg-white text-gray-600 text-xs font-light border-t-[1px] border-gray-200">
                  
//                   <td className="w-[15%] text-left">
//                     <p className="font-[800] text-[#F07F1B] pl-4">{patient?.id}.</p>
//                   </td>
//                   <td className="py-4 w-[20%] text-left">
//                     <p className="font-[600] text-gray-600">{patient?.medicine_name}</p>
                    
//                   </td>

//                   <td className="py-4 px-2 w-[20%] text-center">
//                   <p className="font-[400] text-gray-500 text-[13px]">{patient?.quantity_in_stock}</p>
//                   </td>

                  
//                   <td className="py-4 px-2 w-[20%] text-center">
//                     <span className="font-[400]">{patient?.price}</span>
//                   </td>

//                   <td className="py-4 px-2 w-[20%] text-center">
//                     <span className="font-[400]">{patient?.supplier_name}</span>
//                   </td>

//                   <td className="px-2 w-[20%] text-center">
//                     <button
//                       className="bg-gray-100 text-black px-4 py-1 rounded-md border-2"
//                       onClick={() => navigate(`purchasemedicine/${patient.id}`)} 
//                     >
//                       Update
//                     </button>
//                   </td>
            
                
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
        
//         <PaginationComponent
//           filteredData={filteredData}
//           setPaginatedData={setPaginatedData}
//           itemsPerPage={itemsPerPage}
//           currentPage={currentPage}
//           setCurrentPage={setCurrentPage}
//         />


//       </div>
//     </div>
//   );
// };

// export default MedicineStock;




import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Link, useNavigate } from "react-router-dom";
import PaginationComponent from "../../../Components/PaginationComponent";
import toast from "react-hot-toast";
import medicineService from "../../../Services/medicineService";

const MedicineStock = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getStock = async () => {
      try {
        setLoading(true);
        const response = await medicineService.fetchAll();
        setPatients(response.medicines);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching Medicines");
      }
    };
    getStock();
  }, []);

  useEffect(() => {
    const filteredResult =
      patients?.filter((item) =>
        item?.medicine_name?.toLowerCase().includes(searchData.toLowerCase())
      ) || [];
    setFilteredData(filteredResult);
    setCurrentPage(1);
  }, [searchData, patients]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
  }, [currentPage, filteredData]);

  return (
    <div className="p-6">
      {/* HEADER */}
      <div className="flex items-center justify-between bg-white border border-gray-200 rounded-xl px-6 py-4 mb-5 shadow-sm">
        <div>
          <h1 className="text-[17px] font-[500] text-gray-800">Medicine Stock</h1>
          <p className="text-[12px] text-gray-400 mt-0.5">
            {filteredData?.length || 0} records found
          </p>
        </div>

        <div className="flex items-center gap-3">
          {/* Search */}
          <div className="relative">
            <SearchIcon
              className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
              style={{ fontSize: 16 }}
            />
            <input
              type="search"
              placeholder="Search by name..."
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
              className="pl-8 pr-3 py-[7px] w-[230px] text-[13px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none"
            />
          </div>

          <Link to="purchasemedicine">
            <button              className="relative overflow-hidden bg-gray-800 text-white text-[13px] font-[500] px-4 py-2 rounded-lg border border-gray-300 shadow-md hover:shadow-gray-200 hover:scale-[1.03] active:scale-[0.97] transition-all duration-300 before:absolute before:inset-0 before:-translate-x-full hover:before:translate-x-full before:bg-white/20 before:transition-transform before:duration-500"               
>
              + Medicine
            </button>
          </Link>
        </div>
      </div>

      {/* TABLE */}
      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-800 text-[11px] uppercase text-white">
              <th className="py-3 px-4 text-left">ID</th>
              <th className="py-3 px-4 text-left">Name</th>
              <th className="py-3 px-4 text-center">Qty</th>
              <th className="py-3 px-4 text-center">Price</th>
              <th className="py-3 px-4 text-center">Supplier Name</th>
              <th className="py-3 px-4 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} className="py-10 text-center text-gray-400 text-[13px]">
                  Loading...
                </td>
              </tr>
            ) : paginatedData?.length === 0 ? (
              <tr>
                <td colSpan={6} className="py-10 text-center text-gray-400 text-[13px]">
                  No records found
                </td>
              </tr>
            ) : (
              paginatedData?.map((patient) => (
                <tr
                  key={patient?.id}
                  className="border-t hover:bg-gray-50 text-[13px]"
                >
                  <td className="py-3 px-4 text-gray-500">{patient?.id}</td>
                  <td className="py-3 px-4 font-[500] text-gray-800">
                    {patient?.medicine_name}
                  </td>
                  <td className="py-3 px-4 text-center text-gray-600">
                    {patient?.quantity_in_stock}
                  </td>
                  <td className="py-3 px-4 text-center text-gray-600">
                    {patient?.price}
                  </td>
                  <td className="py-3 px-4 text-center text-gray-600">
                    {patient?.supplier_name}
                  </td>
                  <td className="py-3 px-4 text-center">
                    <button
                      onClick={() => navigate(`purchasemedicine/${patient.id}`)}
                      className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md hover:bg-blue-100 transition-colors"
                    >
                      Update
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default MedicineStock;